import { useEffect, useState } from "react";
import { BillingsTaxiTransferredOrderStatusLegendOption } from "../../types/billings-taxi-transferred-order-status-legend-option";
import useMetaBillingsTaxiTaxiStatusCounters from "../../../../../../../common/services/meta/billings/taxi-taxi/status-counters/use-meta-billings-taxi-taxi-status-counters";
import MetaBillingsTaxiTaxiStatusCounters from "../../../../../../../common/services/meta/billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters";
import useAbort from "../../../../../../../common/hooks/use-abort";
import BillingsTaxiTransferredOrderListingItemBillingStatus from "../../types/billings-taxi-transferred-order-listing-item-billing-status";

export const useBillingsTaxiTransferredOrderStatuses = () => {
  const [statusOptions, setStatusOptions] = useState<
    BillingsTaxiTransferredOrderStatusLegendOption[]
  >([]);
  const { data, load } = useMetaBillingsTaxiTaxiStatusCounters();
  const abort = useAbort();

  const taxiTransferredOrderStatusesData = async () => {
    load(abort.signal);
  };

  useEffect(() => {
    if (!data) {
      taxiTransferredOrderStatusesData();
    } else {
      setStatusOptions(getBillingStatusOptions(data));
    }
  }, [data]);

  return {
    statusOptions,
  };
};

const getBillingStatusOptions = (
  responseData: MetaBillingsTaxiTaxiStatusCounters,
): BillingsTaxiTransferredOrderStatusLegendOption[] => {
  const options: BillingsTaxiTransferredOrderStatusLegendOption[] = [
    {
      status: BillingsTaxiTransferredOrderListingItemBillingStatus.CREATED,
      totalCount: responseData.created,
    },
    {
      status: BillingsTaxiTransferredOrderListingItemBillingStatus.ACCEPTED,
      totalCount: responseData.accepted,
    },
    {
      status: BillingsTaxiTransferredOrderListingItemBillingStatus.REJECTED,
      totalCount: responseData.rejected,
    },
    {
      status: BillingsTaxiTransferredOrderListingItemBillingStatus.REOPENED,
      totalCount: responseData.reopened,
    },
    {
      status:
        BillingsTaxiTransferredOrderListingItemBillingStatus.REOPEN_REQUEST,
      totalCount: responseData.reopenRequest,
    },
  ];

  return options;
};
